// import React from 'react'

// function FinancePlan() {
//   return <div>11</div>
// }

// export default FinancePlan
import '@src/assets/style/main.scss'
import EndlessList from '@src/component/endlessList'
import {AlertModal, ConfirmModal, PersonSelect, PushConfirmModal} from '@src/component/IModal'
import {formatString, RejectReasons, USER_SALE} from '@src/constant'
import {goto} from '@src/route'
import CommonService from '@src/service/commonService'
import {isEmpty} from '@src/util'
import {Picker, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React, {useState} from 'react'

//QualificationItem 资格预审， ApplyItem 分期申请
// 担保申请
import {RenderItem as GuaranteeItem} from '@src/pages/customerInto/components/guarantee-application/index'
// 金融方案
import {RenderItem as FinanceItem} from '@src/pages/customerInto/components/finance-plan'
// 相关合同
import {RenderItem as LeaseItem} from '@src/pages/customerInto/components/lease-contract'
// 放款申请
import {RenderItem as LoanItem} from '@src/pages/customerInto/components/loan-application'
import {ApplicantVo, QualificationVo} from "@src/type";
import {getItemObj} from "@util/store";
import {Button} from "antd-mobile";
import {Subject, throttleTime} from "rxjs";


const CaseType = [
	{value: '0200', label: '资格预审 - 待评估'},
	{value: '0201', label: '资格预审 - 已通过'},
	{value: '0202', label: '资格预审 - 评估失败'},
	{value: '0203', label: '资格预审 - 已驳回'},
	{value: '0209', label: '资格预审 - 已拒绝'},
	{value: '0401', label: '分期申请 - 待申请'},
	{value: '0402', label: '分期申请 - 待初审'},
	{value: '0403', label: '分期申请 - 待复审'},
	{value: '0499', label: '分期申请 - 已拒绝'},
	{value: '0600', label: '担保申请 - 待担保人提交'},
	{value: '0601', label: '担保申请 - 待审核'},
	{value: '0602', label: '担保申请 - 已驳回-需修改资料'},
	{value: '0603', label: '担保申请 - 已驳回-需更换担保人'},
	{value: '0800', label: '金融方案 - 未下发'},
	{value: '0802', label: '金融方案 - 待客户确认'},
	{value: '0803', label: '金融方案 - 已拒绝'},
	{value: '1000', label: '相关合同 - 未推送'},
	{value: '1001', label: '相关合同 - 待签字'},
	{value: '1004', label: '相关合同 - 驳回'},
	{value: '1200', label: '放款申请 - 未提交'},
	{value: '1201', label: '放款申请 - 待审核'},
	{value: '1203', label: '放款申请 - 已驳回'},
	{value: '1202', label: '已通过'},
	{value: '1204', label: '已拒绝'},
	{value: '9988', label: '已过期'}
]

export type QueryResultType = { list: Array<any>; total: number }

export type QueryType = {
	page: number
	content?: string
	status?: number
	financePlanStatus: number
}

let isRequest = false
type FinancePlanStateType = {
	page: number
	list: any[]
	total: number
	params: {
		content: string
		code?: number
	}
	loading?: boolean
}


export default class AllCase extends React.Component<any,
	FinancePlanStateType> {
	ref?: any
	containerRef?: any
	datePickerRef?: any

	constructor(props: any) {
		super(props)
		this.state = {
			page: 0,
			list: [],
			total: 0,
			params: {
				content: '',
			},
		}
	}

	async onRefresh(state?: FinancePlanStateType) {
		if (isRequest) {
			return
		}
		isRequest = true
		const {list, total, page, params} = state || this.state
		if (total && list.length >= total) {
			return
		}
		const newPage = page + 1
		const param: any = {
			...params,
			pages: newPage,
			rows: 10
		}
		if (isEmpty(param.content)) {
			delete param.content
		}
		this.setState({loading: true})
		const data: any = await CommonService.getAllOrders(param)
		isRequest = false
		this.setState({loading: false})
		if (data) {
			let _list: any[] = data.rows || []
			const _total = data.total || 0
			_list = list.concat(_list)
			this.setState({total: _total, list: _list, page: newPage})
		} else {
			Toast.fail('数据加载失败...')
		}
	}

	componentDidMount() {
		isRequest = false
		this.onRefresh()
	}


	filterItemChange(type: 'status' | 'financePlanStatus', value: any) {
		const {params} = this.state
		if (type === 'status') {
			params.code = value
		}

		const state = {params, page: 0, list: [], total: 0}
		this.setState(state)
		this.onRefresh(state)
		this.containerRef?.querySelector('div').scrollTo({top: 0})
	}

	allStatus(array: Array<{ label: string; value: any }>) {
		return [{value: -1, label: '全部'}].concat(array)
	}

	statusText(array: Array<{ label: string; value: any }>, status: any) {
		return array.find((e) => e.value == status)?.label || '全部'
	}

	render() {
		const {list, params, loading, total} = this.state
		const {hide} = this.props
		const noMore = list.length >= total

		return (
			<div className="main-page">
				<div className="main-body">
					<div className="m-tab" style={{display: hide ? 'none' : 'flex'}}>
						<div className="m-query-bar">
							{/* 手机号 */}
							<div className="m-row">
								<input
									className="input"
									value={params.content}
									placeholder="请输入姓名/手机号搜索"
									onChange={(e) => {
										const value = e.target.value
										if (isEmpty(value)) {
											params.content = ''
										} else {
											params.content = value
										}
										this.setState({params})
									}}
								/>
								<div
									className="btn-search"
									onClick={() => {
										const params = this.state.params
										const state = {params, page: 0, list: [], total: 0}
										this.onRefresh(state)
									}}
								>
									搜索
								</div>
							</div>
							{/* 分类选择 */}
							<div className="m-row">
								<div className="m-filter-item">
									<span className="btn-selector-label">状态:</span>
									<Picker
										data={this.allStatus(CaseType)}
										value={
											params.code || params.code === 0
												? [params.code]
												: undefined
										}
										extra="全部"
										cols={1}
										onChange={(e) => {
											let statusValue: any
											if (e && e.length > 0) {
												const value: any = e[0]
												statusValue = value
											} else {
												statusValue = undefined
											}
											this.filterItemChange('financePlanStatus', statusValue)
										}}
									>
                  <span className="btn-selector-value">
                    {this.statusText(CaseType, params.code)}
                  </span>
									</Picker>
								</div>
							</div>
						</div>
						{/* list body */}
						<div className="m-body" ref={this.containerRef}>
							<EndlessList
								onTouchBottom={this.onRefresh.bind(this)}
								loading={loading}
								noMore={noMore}
							>
								<div className="m-list">
									{list.map((e, i) => (
										<RenderItem
											data={e}
											key={i}
											onRefresh={() => {
												const state = {
													...this.state,
													page: 0,
													list: []
												}
												this.setState(state)
												this.onRefresh(state)
											}}
										/>
									))}
								</div>
							</EndlessList>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


const queryParam = {
	id: 0,
	beforeStatus: 0,
}

let reason = ''

class RenderItem extends React.Component<{ data: any, onRefresh: () => void }, any> {

	contactSubObj = new Subject()
	currentId = 0

	constructor(props: any) {
		super(props);
		this.state = {
			visible: false,
			reasonVisible: false,
			selectVisible: false,
			pushing: false
		}

		this.contactSubObj.pipe(throttleTime(3000)).subscribe(() => {
			this.okConfirm()
		})
	}

	// 推送合同
	okConfirm() {
		if (this.state.pushing) {
			return
		}
		this.setState({
			pushing: true,
			loadingVisible: true
		})


		CommonService.pushContrack({loaningInfoId: this.currentId})
			.then(() => {
				const {params} = this.state
				const state = {
					params,
					page: 0,
					list: [],
					total: 0,
					selectVisible: false,
					loadingVisible: false,
					pushing: false
				}
				this.setState(state)
				// todo
				this.props.onRefresh()
				Toast.show('操作成功')
			})
			.catch((err) => {
				Toast.show(err)
				this.setState({
					selectVisible: false,
					loadingVisible: false,
					pushing: false
				})
			})
	}


	// 编辑状态
	centerEditStatus(val: string) {
		CommonService.editStatus({
			loaningInfoId: queryParam.id.toString(),
			status: '6',
			reason: val,
			beforeStatus: queryParam.beforeStatus.toString(),
		}).then(() => {
			const {params} = this.state
			const state = {params, page: 0, list: [], total: 0, visible: false}
			this.setState(state)
			// todo
			this.props.onRefresh()
		})
	}

	// 填写原因
	showModal(id: number, beforeStatus: number) {
		this.setState({visible: true})
		queryParam.id = id
		queryParam.beforeStatus = beforeStatus
	}

	showReason(val: string) {
		reason = val
		this.setState({reasonVisible: true})
	}

	// 查看原因
	showConfirm(val: number) {
		this.setState({
			selectVisible: true,
		})
		this.currentId = val
	}

	onOkConfirmHandle() {
		this.contactSubObj.next(null)
	}

	render() {
		const {data} = this.props
		const {step} = data;

		const {visible, reasonVisible, selectVisible, pushing} = this.state;
		let content
		// 判定阶段
		if (step == 'qualification') {
			//资格预审
			content = <QualificationItem data={data} callback={(d) => {
				// 指派成功的回调
				this.props.onRefresh()
			}}/>
		} else if (step == 'loan') {
			//分期申请
			content = <ApplyItem data={data}/>
		} else if (step == 'guarantee') {
			//guarantee - 担保申请
			content = <GuaranteeItem data={data}/>
		} else if (step == 'financePlan') {
			//financePlan - 金融方案
			content =
				<FinanceItem  data={data} show={this.showModal.bind(this)} showReason={this.showReason.bind(this)}/>
		} else if (step == 'contractInfo') {
			//contractInfo-相关合同
			content = <LeaseItem data={data}
								 show={this.showModal.bind(this)}
								 showReason={this.showReason.bind(this)}
								 showConfirm={this.showConfirm.bind(this)}
			/>
		} else if (step == 'grantApply') {
			//grantApply-放款申请
			content = <LoanItem data={data}
								show={this.showModal.bind(this)}
								showReason={this.showReason.bind(this)}
								showConfirm={this.showConfirm.bind(this)}/>
		}


		return (
			<>
				{visible && (
					<PushConfirmModal
						visible={visible}
						onOk={this.centerEditStatus.bind(this)}
						onCancel={() => this.setState({visible: false})}
					/>
				)}
				{reasonVisible && (
					<AlertModal
						visible={reasonVisible}
						title="原因"
						content={<div style={{textAlign: 'center'}}>{reason}</div>}
						onOk={() => this.setState({reasonVisible: false})}
					/>
				)}

				{selectVisible && (
					<ConfirmModal
						visible={selectVisible}
						onOk={this.onOkConfirmHandle.bind(this)}
						okText={pushing ? '推送中' : '确认'}
						content="确认将相关合同推送给用户签字?"
						onCancel={() => this.setState({selectVisible: false})}
					/>
				)}
				{content}
			</>


		)
	}
}


const QuaStatus: any = {
	0: '待评估',
	1: '已通过',
	2: '评估失败',
	3: '已驳回',
	9: '已拒绝',
	88: '已过期'
}

export function QualificationItem(props: {
	data: any
	callback: (data?: any) => void
}) {
	const {data, callback} = props
	const [selectVisible, setSelectVisible] = useState(false)
	const {isManager, userType} = getItemObj('userInfo')

	const asign = (userId: any) => {
		CommonService.asignByDealerManager({
			qualificationId: data.id,
			salesType: 1,
			managerId: userId,
		}).then(() => {
			Toast.show('操作成功')
			callback?.(data)
		})
	}

	return (
		<>
			<div className="m-list-item" style={{position: 'relative'}}>
				<div className="row">
					<div className="label name">{data.insuredName}</div>
					<div className="value">{data.mobile}</div>
				</div>
				<div className="row">
					<div className="label">申请时间</div>
					<div className="value">
						{data.applyTime &&
						moment(data.applyTime).format('yyyy-MM-DD HH:mm')}
					</div>
				</div>
				<div className="row">
					<div className="label">意向车型</div>
					<div className="value">{data.brandName} {data.vehicleName}</div>
				</div>
				<div className="row">
					<div className="label">评估进度</div>
					<div className="value">{QuaStatus[data.qualificationStatus]}</div>
				</div>
				{data.reason && data.status === '已拒绝' ? (
					<div className="row">
						<div className="label">拒绝原因</div>
						<div className="value">{data.reason}</div>
					</div>
				) : null}
				{data.status === '已驳回' && data.reject_type ? (
					<div className="row">
						<div className="label">驳回原因</div>
						<div className="value">{RejectReasons[data.reject_type]}</div>
					</div>
				) : null}
				{data.saleName && isManager === 1 && (
					<div className="row">
						<div className="label">跟单销售</div>
						<div className="value">{data.saleName}</div>
					</div>
				)}
				{userType === USER_SALE && isManager === 1 && (
					<Button
						color="primary"
						size="small"
						style={{
							'--background-color': '#6291DF',
							position: 'absolute',
							bottom: 10,
							right: 10,
						}}
						onClick={() => {
							setSelectVisible(true)
						}}
					>
						指派
					</Button>
				)}
			</div>
			{selectVisible && isManager === 1 && (
				<PersonSelect
					visible={selectVisible}
					onOk={asign}
					onCancel={() => setSelectVisible(false)}
				/>
			)}
		</>
	)
}


const ApplyStatus: any = {
	1: '待申请', 2: '待初审', 3: '待复审', 4: '复审通过', 5: '已放款', 88: '已过期', 99: '已拒绝'
}

function ApplyItem(props: { data: any }) {
	const {data} = props
	return (
		<div className="m-list-item">
			<div className="row">
				<div className="label name">{data.insuredName}</div>
				<div className="value">{data.mobile}</div>
			</div>
			<div className="row">
				<div className="label">申请时间</div>
				<div className="value">
					{data.submitTime &&
					moment(data.submitTime).format('yyyy-MM-DD HH:mm')}
				</div>
			</div>
			<div className="row">
				<div className="label">申请车型</div>
				<div className="value">
					{data.brandName} {data.vehicleName}
				</div>
			</div>
			<div className="row">
				<div className="label">审批进度</div>
				<div className="value">{ApplyStatus[data.loanStatus]}</div>
			</div>
			<div className="row">
				<div className="label">更新时间</div>
				<div className="value">
					{data.uptime &&
					moment(data.uptime).format('yyyy-MM-DD HH:mm')}
				</div>
			</div>
			{data.rejectReason && (
				<div className="row">
					<div className="label">驳回原因</div>
					<div className="value">{data.rejectReason}</div>
				</div>
			)}
			{data.refusedReason && (
				<div className="row">
					<div className="label">拒绝原因</div>
					<div className="value">{data.refusedReason}</div>
				</div>
			)}
		</div>
	)
}
